import React from 'react';
import { DialogAction } from 'components/v2/FlexTable/BatchAction';
import { adaptToBulkRemindRequest } from 'adapters/v1/digitalFormRequests/formData';

import { withFeatureState } from './state';

const Remind = withFeatureState(({ bulkRemind, selected, ...props }) => {
  const onConfirm = async (formData) => {
    if (!selected || !selected.length || !bulkRemind) return;
    const adapted = adaptToBulkRemindRequest({ selected });
    const resp = await bulkRemind(adapted);
    return resp;
  };

  const actionProps = {
    title: 'Remind',
    icon: 'Mail',
    action: 'remind',
    object: 'people',
    onConfirm,
  };

  return <DialogAction {...props} {...actionProps} />;
});

const batchActions = ({ permissions }) => {
  if (!permissions) return [];

  const actions = [
    {
      action: Remind,
      permission: permissions.digitalFormRequests.update,
    },
  ];

  return {
    batchActions: actions.filter((action) => action.permission).map((action) => action.action),
  };
};

export default batchActions;
